import { render } from "./BaseNavigation.vue?vue&type=template&id=c54ea68a&scoped=true"
import script from "./BaseNavigation.vue?vue&type=script&lang=js"
export * from "./BaseNavigation.vue?vue&type=script&lang=js"

import "./BaseNavigation.vue?vue&type=style&index=0&id=c54ea68a&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54ea68a"]])

export default __exports__